import React from 'react';
import { connect } from 'react-redux';
import config, { template } from '../../constants/Configs';

import Utils from '../../services/Utils';
import { LocalStorageService } from '../../services/LocalStorageService';
import { CustomisationHelper } from '../../services/helpers/CustomisationHelper'
import { ColorModeEnum, COLOR_MODE_KEY } from '../../constants/Enums/UiEnum';
import { PopupColorModeEnum } from './PopupEnum';
import UrlHelper from '../../services/helpers/UrlHelper';

class LogoImage extends React.PureComponent {
    constructor(props) {
        super(props);
        this.imgRef = React.createRef();
        this.state = {
            imageStatus: "",
            logoSize: {}
        };
    }

    resizeHandler = () => {
        if (Utils.isTablet() && this.imgRef.current) {
            this.imgRef.current.style.width = null
            this.setState({
                logoSize: { ...this.state.logoSize, width: this.imgRef.current.clientWidth }
            });
        }
    }

    componentDidMount() {
        this.handleImageLoaded()
        window.addEventListener("resize", this.resizeHandler);
    }
    
    componentDidUpdate(prevProps) {
        if(prevProps.colorMode !== this.props.colorMode && !Utils.isTablet()){
            this.imgRef.current.style.width = null
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resizeHandler)
    }

    handleImageLoaded() {
        this.setState({
            imageStatus: "loaded",
            logoSize: { ...(this.imgRef.current?.clientWidth ? { width: this.imgRef.current.clientWidth } : {}), ...(this.imgRef.current?.naturalHeight ? { height: this.imgRef.current.naturalHeight } : {}) }
        });
        this.props.onLoad && this.props.onLoad(this.imgRef.current?.clientWidth, this.imgRef.current?.naturalHeight)
    }

    handleImageErrored() {
        this.setState({ imageStatus: "failed" });
    }

    getLogoUrl() {
        const isMobile = Utils.isTablet()
        // const storageData = LocalStorageService.get(COLOR_MODE_KEY)
        const { logo = {} , isLogoFavicon} = this.props;
        const isInvert = CustomisationHelper.IsInvertedColorModeSelected()
        const faviconUrl = logo.faviconUrl?.value
        const mobileLogoUrl = isInvert && logo.invertMobileLogoUrl?.value ? logo.invertMobileLogoUrl?.value  : logo.mobileLogoUrl?.value
        const logoUrl = isInvert && logo.invertLogoUrl?.value  ? logo.invertLogoUrl?.value : logo.logoUrl?.value
      
        const lastUpdateTime = isInvert ? logo[isMobile ?'invertMobileLogoUrl':'invertLogoUrl']?.lastUpdateTime : logo[isMobile ?'mobileLogoUrl':'logoUrl']?.lastUpdateTime
        const defaultLogo = `${config.DEFAULT_SITE_URL}/templates/${template}/img/logos/logo.svg`;
        
        const mobileLogo = mobileLogoUrl ?mobileLogoUrl.indexOf('data:image') >= 0 ? mobileLogoUrl : `/${mobileLogoUrl}?v=${lastUpdateTime}` : null;
        const desktopLogo =  logoUrl ?logoUrl.indexOf('data:image') >= 0 ? logoUrl : `/${logoUrl}?v=${lastUpdateTime}` : null;
        const faviconLogo = faviconUrl ? faviconUrl.indexOf('data:image') >= 0 ? faviconUrl : `/${faviconUrl}?v=${logo.faviconUrl.lastUpdateTime}` : null;
        
        let logoURL;
        if(isLogoFavicon) {
           
            logoURL = faviconLogo ? faviconLogo : defaultLogo;
        } else {
            if(isMobile) {
                logoURL = mobileLogo ? mobileLogo : (desktopLogo ? desktopLogo : defaultLogo);
            } else {
                logoURL = desktopLogo ? desktopLogo : defaultLogo;
            }
        }
        return logoURL;
    }


    render() {
        const { logo, className = "" } = this.props;
        const logoURL = this.getLogoUrl();
        return logo ? <img
            ref={this.imgRef}
            style={{ ...this.state.logoSize }}
            onError={this.handleImageErrored.bind(this)}
            onLoad={this.handleImageLoaded.bind(this)}
            className={`${className} ${this.state.imageStatus}`}
            alt="logo"
            src={ UrlHelper.getStaticFileUrl(logoURL)} /> : null
    }
}
const mapStateToProps = state => {
    return {
        colorMode: state.settings.uiSettingMode,
        popUpsColorMode: state.settings.popUpsColorMode
    }
};

export default connect(
    mapStateToProps,
    null
)(LogoImage);
